import { createFileRoute } from "@tanstack/react-router"
import { ZendeskIntegrationModal } from "modules/settings/components/integrations/zendesk/ZendeskIntegrationModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/zendesk/connect")({
  component: ZendeskIntegrationModal,
})
